import React from 'react';

const FormBuilderContext = React.createContext(true);

export const FormBuilderProvider = FormBuilderContext.Provider;
export default FormBuilderContext;
